/** Server marks uploads blocked when `status.suspended` is true on company storage snapshot. */

export const STORAGE_QUOTA_EVIDENCE_MESSAGE =
  "Your company has reached its storage quota, so this file could not be uploaded. Please speak with your company administrator, they can increase the storage subscription, or contact Rail Intel support if needed.";

export const STORAGE_QUOTA_START_ASSESSMENT_BODY =
  "Your company has reached its storage quota. You will not be able to attach evidence until your company administrator increases the storage subscription, or contacts Rail Intel support if needed.";

export const STORAGE_QUOTA_START_ASSESSMENT_QUESTION = "Continue with this assessment anyway?";

export const STORAGE_QUOTA_OPEN_ASSESSMENT_BODY =
  "Due to storage quota exceeded for your company, you will not be able to attach supporting evidence or uploads for your assessment. Your company administrator must increase storage capacity for your company.";

export const STORAGE_QUOTA_OPEN_ASSESSMENT_QUESTION = "Are you sure you wish to continue with the assessment?";

/** Shown on the company dashboard when usage is at or over the company storage limit (uploads blocked). */
export const STORAGE_QUOTA_DASHBOARD_BANNER_MESSAGE =
  "Your company has reached its storage limit. Documents and photos cannot be uploaded, including attachments during assessment events, until a company administrator increases your storage subscription.";

export async function fetchCompanyStorageSuspended(
  companyCode: string,
  userEmail: string | undefined | null
): Promise<boolean> {
  const code = String(companyCode || "").trim();
  const email = String(userEmail || "").trim();
  if (!code || !email) return false;
  try {
    const res = await fetch(`/api/storage/company/${encodeURIComponent(code)}`, {
      headers: { "X-User-Email": email, "X-Company-Code": code },
    });
    if (!res.ok) return false;
    const data = (await res.json()) as { status?: { suspended?: boolean } };
    return data?.status?.suspended === true;
  } catch {
    return false;
  }
}
